module.exports = __webpack_public_path__ + "img/4-w.61ae5025.jpg";